import React from 'react'
import PropTypes from 'prop-types'

import states from '../util/states'

const stateList = missingState => Object.keys(states)
  .filter(state => state !== missingState)
  .sort((a, b) => states[a] > states[b] ? 1 : -1)
  .map(state => (
    <option key={state} value={state}>{states[state]}</option>
  ))

const StateComparisonSelect = ({ selected, state, changeHandler }) => (
  <div className="cmwd--state-comparison-select-group">
    <label htmlFor="cmwf--state-comparison-select">Compare {states[state]} to:</label>
    {' '}
    <select
      id="cmwf--state-comparison-select"
      className="select__small"
      onChange={e => changeHandler(e.target.value)}
      value={selected}
    >
      <option value="">-- None --</option>
      {stateList(state)}
    </select>
  </div>
)

StateComparisonSelect.propTypes = {
  changeHandler: PropTypes.func.isRequired,
  selected: PropTypes.string.isRequired,
  state: PropTypes.string.isRequired,
}

export default StateComparisonSelect



// WEBPACK FOOTER //
// ./src/components/Visualizations/components/state-comparison-select.jsx